export function getLanguage() {
  return window.localStorage.getItem('lang') || 'fr';
}
